import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Calendar, { onDayClick } from './nth-calendar';

class ReturnsCalendar extends PureComponent {
  selectedDays = (day) => {
    const { selectedDay } = this.props;

    if (selectedDay === null) return false;

    return day.getTime() === selectedDay.getTime();
  };

  dayClickHandler = (...args) => {
    const selectedDay = onDayClick(...args);
    const {
      props: { handleDaySelect },
    } = this;

    handleDaySelect(selectedDay);
  };

  render() {
    const {
      selectedDays,
      dayClickHandler,
      props,
      props: { include },
    } = this;

    return (
      <Calendar
        {...props}
        selectedDays={selectedDays}
        onDayClick={dayClickHandler}
        include={include}
      />
    );
  }
}

ReturnsCalendar.defaultProps = {
  selectedDay: null,
  handleDaySelect: () => {},
  include: null,
};

ReturnsCalendar.propTypes = {
  selectedDay: PropTypes.instanceOf(Date),
  handleDaySelect: PropTypes.func,
  include: PropTypes.arrayOf(PropTypes.instanceOf(Date)),
};

export default ReturnsCalendar;
